import { render, staticRenderFns } from "./PrettySelect.vue?vue&type=template&id=51c0f5fb&scoped=true&"
import script from "./PrettySelect.vue?vue&type=script&lang=js&"
export * from "./PrettySelect.vue?vue&type=script&lang=js&"
import style0 from "./PrettySelect.vue?vue&type=style&index=0&id=51c0f5fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0f5fb",
  null
  
)

export default component.exports